<template>
  <!-- partial -->
  <div class="page-content">
    <div class="row">
      <div class="col-lg-7 col-md-7 col-sm-6 col-xs-12">
        <h5 class="txt-dark">
          Financial Year & Quarters &nbsp;
          <add-button
            link="/environment-management/financial-year-quarters/create"
          ></add-button>
        </h5>
      </div>
      <!-- Breadcrumb -->
      <div class="col-lg-5 col-sm-6 col-md-5 col-xs-12">
        <ol class="breadcrumb breadcrumb-line" style="float: right">
          <li class="breadcrumb-item">
            <router-link :to="`/`">Dashboard</router-link>
          </li>
          <li class="breadcrumb-item">Environment Management</li>
          <li class="breadcrumb-item">Financial Year & Quarters</li>
          <li class="breadcrumb-item active" aria-current="page">List</li>
        </ol>
      </div>
    </div>
    <!-- /Breadcrumb -->
    <!-- Search & Filtering  -->
    <div class="col-md-12 grid-margin stretch-card">
      <div class="card">
        <div class="card-body">
          <div class="col-lg-8 col-md-8 col-sm-6 col-xs-12">
            <input
              type="text"
              class="form-control"
              placeholder="Search..."
              v-model="searchData"
              @keydown.enter="search"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- Search & Filtering  -->
    <!-- Table -->
    <div class="row">
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <!-- Export To Excel -->
            <div class="row">
              <div class="col-md-8"></div>
              <div class="col-md-4">
                <div style="float: right">
                  <a
                    href="#"
                    class="btn btn-primary"
                    v-if="Exportfinancial_year_quarters.length == 0"
                    @click="exportToExcel"
                  >
                    <span v-if="isExcelloading">
                      <div class="d-flex align-items-center">
                        <strong>Generating Excel</strong>
                        &nbsp;
                        <div
                          class="
                            spinner-border
                            text-light
                            spinner-border-sm
                            ms-auto
                          "
                          role="status"
                          aria-hidden="true"
                        ></div>
                      </div>
                    </span>
                    <span v-else>Generate Excel</span>
                  </a>
                  <download-excel
                    :title="title"
                    v-else
                    class="btn btn-success"
                    :data="financial_year_quarters_excel"
                    :fields="excel_fields"
                    worksheet="Financial Year & Quarters"
                    name="Financial Year & Quarter.xls"
                    >Download Excel
                  </download-excel>
                </div>
              </div>
            </div>
            <br />
            <!-- End Export to Excel -->
            <div class="table-responsive">
              <table id="dataTableExample" class="table table-hover">
                <thead>
                  <tr>
                    <th>Sr No</th>
                    <th>Financial Year</th>
                    <th>From Month</th>
                    <th>To Month</th>
                    <th>From Year</th>
                    <th>To Year</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- Table Loader -->
                  <loading-table
                    :isLoading="isLoading"
                    cols="8
                        "
                  ></loading-table>
                  <!-- If No Data Received-->
                  <tr v-if="financial_year_quarters.length == 0">
                    <td colspan="8" class="text-center" style="color: grey">
                      No Data Found
                    </td>
                  </tr>
                  <!-- If data Received -->
                  <tr
                    v-for="(
                      financial_year_quarter, at
                    ) in financial_year_quarters"
                    :key="`financial_year_quarter${at}`"
                  >
                    <td>{{ serialNoStarting + at + 1 }}</td>
                    <td>{{ financial_year_quarter.financial_year }}</td>
                    <td>{{ financial_year_quarter.from_month }}</td>
                    <td>{{ financial_year_quarter.to_month }}</td>
                    <td>{{ financial_year_quarter.from_year }}</td>
                    <td>{{ financial_year_quarter.to_year }}</td>
                    <td>
                      <div>
                        <router-link
                          :to="`/environment-management/financial-year-quarters/${financial_year_quarter.id}`"
                          tag="button"
                          class="btn btn-primary btn-sm"
                          >Edit</router-link
                        >
                        &nbsp; &nbsp;
                        <button
                          class="btn btn-danger btn-sm"
                          @click="delete_data(financial_year_quarter.id)"
                        >
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- /Table -->
            </div>
            <pagination :count="count" @submit="getData"></pagination>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- partial -->
</template>

<script type="text/javascript">
import axios from "axios";

export default {
  name: "approvallimit",
  data() {
    return {
      financial_year_quarters: [],
      count: 0,
      serialNoStarting: 1,
      isLoading: false,
      isExcelloading: false,
      searchData: "",
      financial_year_quarters_excel: [],
      excel_fields: {
        "Sr No": "sr_no",
        "Financial Year": "financial_year",
        "From Month": "from_month",
        "To Month": "to_month",
        "From Year": "from_year",
        "To Year": "to_year",
      },
      Exportfinancial_year_quarters: [],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    // async getData() {
    async getData(page = 1) {
      this.isLoading = true;
      let financial_year_quarters = await axios.get(
        `/financial_year_quarters?page=${page}&rowsPerPage=${this.rowsPerPage}`
      );
      this.financial_year_quarters = financial_year_quarters.data.data;
      this.count = financial_year_quarters.data.count;
      this.serialNoStarting = (page - 1) * this.rowsPerPage;
      this.isLoading = false;
    },
    async search() {
      this.isLoading = true;
      let financial_year_quarters = await axios.get(
        `/financial_year_quarters?search=${this.searchData}`
      );
      this.financial_year_quarters = financial_year_quarters.data.data;
      this.count = financial_year_quarters.data.count;
      this.isLoading = false;
    },
    async exportToExcel() {
      this.isExcelloading = true;
      this.title = "Financial Year & Quarter Data";
      this.financial_year_quarters_excel = [];
      let Exportfinancial_year_quarters = [];
      Exportfinancial_year_quarters = await axios.get(
        `/financial_year_quarters`
      );
      this.Exportfinancial_year_quarters =
        Exportfinancial_year_quarters.data.data;
      let sr_no = 1;
      this.Exportfinancial_year_quarters.forEach((financial_year_quarter) => {
        this.financial_year_quarters_excel.push({
          sr_no: sr_no,
          financial_year: financial_year_quarter.financial_year
            ? financial_year_quarter.financial_year
            : "",
          to_month: financial_year_quarter.to_month
            ? financial_year_quarter.to_month
            : "",
          from_month: financial_year_quarter.from_month
            ? financial_year_quarter.from_month
            : "",
          to_year: financial_year_quarter.to_year
            ? financial_year_quarter.to_year
            : "",
          from_year: financial_year_quarter.from_year
            ? financial_year_quarter.from_year
            : "",
        });
        sr_no++;
      });
      this.isExcelloading = false;
    },
    async delete_data(id) {
      let check = confirm("Are you sure you want to delete the data");
      if (check) {
        try {
          this.isLoading = true;
          await axios.post(
            `delete?id=${id}&table_name=financial_year_quarters`
          );
          this.isLoading = false;
          this.getData();
        } catch (e) {
          this.isLoading = false;
        }
      }
    },
  },
};
</script>
